import { Flex, Grid, Text } from "theme-ui";

export const SidebarTable = ({ header, rows }) => {
    return (
        <Grid gap={2} sx={{ width: '100%' }}>
            <Flex sx={{ justifyContent: 'center', width: '100%', backgroundColor: 'darker' }}>
                <Text py={2} sx={{ color: 'white', fontWeight: 600 }}>{header}</Text>
            </Flex>
            {rows?.map((row, index) => (
                <Flex key={`${row.name}${index}`} sx={{ justifyContent: 'space-between', borderBottom: '1px solid black' }}>
                    <Text as="p" sx={{ fontSize: '16px', color: 'darker' }}>{row.name}</Text>
                    <Text as="p" sx={{ fontSize: '16px', color: 'darker' }}>{row.value}</Text>
                </Flex>
            ))}
        </Grid>
    );
};